import $ from 'jquery';
window.$ = $;
